import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Col, Container, Modal, Row } from "react-bootstrap";
import shape from "../../../assets/images/team/feture-bg-shape.png";
import dots from "../../../assets/images/team/dots-1.png";
import { Link } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";

const TeamSection = () => {
  const [cmsData, setCmsData] = useState([]);
  const [baseurl, setBaseurl] = useState([]);
  const [imagePath, setimagePath] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [teacherSettings, setTeacherSettings] = useState(null);
  const handleShow = (mentor) => {
    setSelectedTeacher(mentor);
    setShow(true);
  };


  useEffect(() => {
    fetchCMSData();
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      const filteredTeachers = res.data.data
        .filter((item) => item.type === "teachers")
        .sort((a, b) => Number(a.tec_position) - Number(b.tec_position));
      setCmsData(filteredTeachers);
      setTeacherSettings(res.data.home_setting[0])
      console.log("Home Setting:", res.data.home_setting);
      setBaseurl(res.data.imagePath);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 1.1 },
      },
    ],
  };

  return (
    <section className="team teachers py-60">
      <Container>
        <img src={dots} alt="" className="dots" loading="lazy"/>
        {/* <img src={tag} alt="tag" className="tag" /> */}

        <Row className="align-items-center">
          {/* <Col xl={12}>
            <div className="team_one__content mb-24 mb-xxl-0 sec-title p-0 text-center">
              <div className="heading mb-16">
                <h6 className="color-primary mb-8">–––– Our Teachers</h6>
                
                <h2>
                  Faces from Our {""}{" "}
                  <span className="fm-sec">Faculty Team.</span>
                </h2>
              </div>
              <p className="mb-24">
                Practical case studies, real-world judgments, and interactive
                discussions
              </p>
            </div>
          </Col> */}
          <Col xl={12}>
            <div className="team_one__content mb-24 mb-xxl-0 sec-title p-0 text-center">
              <div className="heading mb-16">
                <h6 className="color-primary mb-8">–––– Our Teachers</h6>
                {teacherSettings && (
                  <h2 dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(teacherSettings?.teachers_title || ""),
                        }}
                  >
                   {/* {teacherSettings.teachers_title} */}
                   
                  </h2>
                )}

              </div>
            </div>
          </Col>


          <Col xl={12}>
            <Slider {...settings} className="all_teams">
              {cmsData.map((teacher, index) => (
                <div className="px-2">
                  <div key={index} className="team__card mb-24">
                    <div className="team__img_block">
                      <img
                        src={`${baseurl}/${teacher.image}`}
                        alt={teacher.name}
                        className="team_img" loading="lazy"
                      />
                      <div className="team__content_block">
                        <div className="team__text_block">
                          <h5 className="mb-8">
                            <Link to="#">{teacher.name}</Link>
                          </h5>
                          <ul className="team__info unstyled mb-16">
                            <li>
                              {/* <span>
                                <FaGraduationCap />
                              </span> */}

                              {teacher.founder_post}
                            </li>
                          </ul>
                          <p
                            className="team_info_text mb-24"
                          // dangerouslySetInnerHTML={{
                          //   __html: teacher.description,
                          // }}
                          >
                            <Link
                              onClick={() => handleShow(teacher)}
                              className="educate-btn sm"
                            >
                              See Detail
                            </Link>
                          </p>

                          <img
                            src={shape}
                            alt="shape_Bottom"
                            className="text_block_bg_shape"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>

      {show && selectedTeacher && (
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="enquire_form mentor"
          backdrop="static"
          size="lg"
        >
          <button
            type="button"
            className="custom-close-btn"
            onClick={handleClose}
          >
            ×
          </button>

          <Modal.Body>
            <div className="team__model">
              <Row className="align-items-center">
                <Col lg={5} md={6}>
                  <div className="modal_content_left">
                    <img
                      src={
                        selectedTeacher?.image
                          ? `${imagePath}${selectedTeacher.image}`
                          : ""
                      }
                      alt={selectedTeacher?.name}
                      className="team_img"
                    />
                    <div className="mentor_info">
                      <h5 className="mb-8">
                        <Link to="#">{selectedTeacher?.name}</Link>
                      </h5>
                      <p>{selectedTeacher?.founder_post}</p>
                    </div>
                  </div>
                </Col>
                <Col lg={7} md={6}>
                  <div className="team_right_info">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: selectedTeacher?.description,
                      }}
                    ></p>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </section>
  );
};

export default TeamSection;
